import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{
  btnColor?: string
  buttonTextColor?: string
}>()((theme, { btnColor, buttonTextColor }) => ({
  button: {
    backgroundColor: btnColor ? btnColor : theme.palette.secondary.dark,
    color: buttonTextColor || theme.palette.common.white,
    width: '100%',
    '&:hover': {
      backgroundColor: btnColor ? btnColor : theme.palette.secondary.dark,
      opacity: 0.9,
    },
    '&.Mui-disabled': {
      color: theme.palette.primary.light,
      backgroundColor: theme.palette.secondary.main,
      fontWeight: 500,
    },
    borderRadius: theme.spacing(0.5),
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    textTransform: 'initial',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    marginTop: theme.spacing(2),
    height: theme.spacing(7.125),
  },
  textField: {
    fontSize: '16px',
  },
  customAlert: {
    margin: theme.spacing(2.5, 0),
    fontSize: '14px',
  },
  policy: {
    paddingTop: theme.spacing(7),
    color: theme.palette.check.light,
    fontSize: '13px',
  },
  headingMessage: {
    fontSize: '18px',
  },
  link: {
    color: theme.palette.select.light,
    fontWeight: 500,
    fontSize: '13px',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  customFormInnerContainer: {
    maxHeight: theme.spacing(20),
    overflowY: 'auto',
  },
}))
